import Swal from 'sweetalert2';
import i18n from 'i18n/config';

import { store } from 'redux/store';
import { Council, Society, User } from 'types';

import { addAlert } from 'modules/_shared/redux/alertActions';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';

import { deleteCouncil as deleteCouncilAction } from 'modules/administratives/redux/councilActions';
import eventTypes from 'constants/eventTypes';
import trackEvent from 'utils/trackEvent';

type DeleteCouncilProps = {
  council: Council;
  user: User;
  actualSociety: Society;
  mixpanel: any;
};

export const deleteCouncil = async (params: DeleteCouncilProps) => {
  const { council, user, actualSociety, mixpanel } = params;

  const title = `<h4 class="nk-modal-title">${i18n.t(
    'AreYouSureAboutDelCouncil'
  )}</h4>`;

  const html = `<h5 class="text-primary">${
    council.name
  }</h5><br /><div class="caption-text">${i18n.t(
    'ThisProcedureCantUndo'
  )}</div>`;

  Swal.fire({
    icon: 'warning',
    title,
    html,
    confirmButtonText: i18n.t('OkDelete'),
    confirmButtonColor: '#6576ff',
    allowOutsideClick: false,
    showCancelButton: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await store.dispatch(deleteCouncilAction(council._id as string));
        store.dispatch(addAlert(alertBodyTypes.COUNCIL_DELETED_SUCCESSFULLY));

        const currentEvent = eventTypes.DELETE_COUNCIL;
        trackEvent(mixpanel, currentEvent, {
          userId: user?.['_id'],
          userName: user?.name,
          userEmail: user?.email,
          societyId: actualSociety?.['_id'],
          societyName: actualSociety?.name,
          operation: currentEvent,
        });
      } catch (error) {
        store.dispatch(addAlert(alertBodyTypes.ERROR_DELETING_COUNCIL));
      }
    }
  });
};
